import { ReactNode, createContext, memo, useEffect, useState } from 'react';

import {
  SnackbarResult,
  SnackbarType,
  useSnackbarContext,
} from './snackbarContext';

import { Snackbar } from ".";


export const SnackbarContext = createContext<SnackbarResult>(
  {} as SnackbarResult,
);

export const SnackbarProvider = memo(
  ({ children }: { children: ReactNode }) => {
    const context = useSnackbarContext();

    const [snackbar, setSnackbar] = useState<SnackbarType | undefined>();

    useEffect(() => {
      const { currentSnackbar } = context;
      setSnackbar(currentSnackbar);
    }, [context, context.currentSnackbar]);

    const { message, ...snackbarProps } = snackbar || {};

    return (
      <SnackbarContext.Provider value={context}>
        {children}
        {snackbar && (
          <Snackbar {...snackbar} {...snackbarProps} Message={message} />
        )}
      </SnackbarContext.Provider>
    );
  },
);
